(function(){
if(window.__hmHolidayDrawerGift)return;window.__hmHolidayDrawerGift=true;
var busy=false;
var lastZeroCleanup=0;
async function cleanupZeroGiftCart(){
 if(busy || Date.now()-lastZeroCleanup<1500)return;
 lastZeroCleanup=Date.now();
 try{
  var response=await fetch('/cart.js',{credentials:'same-origin'});
  if(!response.ok)return;
  var cart=await response.json();
  if(cart.items.some(function(i){return i.variant_id===47215837085863;}))return;
  var attrs=cart.attributes||{},clear={},found=false;
  Object.keys(attrs).forEach(function(k){
   if(k==='gift-note'||k==='gift-wrapping-instructions'||/^gift [0-9]+ (contents|message)$/.test(k)){
    if(attrs[k]){clear[k]='';found=true;}
   }
  });
  if(found)await fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:clear})});
 }catch(e){console.warn('Gift cleanup deferred',e);}
}
document.addEventListener('cartdrawer:opened',cleanupZeroGiftCart);
async function syncDrawerGift(){
 if(busy)return;
 var root=panel();if(!root)return;
 try{
  var response=await fetch('/cart.js',{credentials:'same-origin'});if(!response.ok)return;
  var cart=await response.json(),item=cart.items.find(function(x){return x.variant_id===47215837085863;});
  var n=item?item.quantity:0;
  render(root,n);
  if(!item){
   root.querySelectorAll('[data-dg-contents],[data-dg-message]').forEach(function(el){el.value='';});
  }
 }catch(e){console.warn('gift drawer sync deferred',e);}
}
document.addEventListener('cartdrawer:opened',syncDrawerGift);
function syncFromCartEvent(event){
 if(busy)return;
 var root=panel();if(!root)return;
 var cart=event&&event.detail&&event.detail.cart;
 if(!cart||!Array.isArray(cart.items)){syncDrawerGift();return;}
 var wrap=cart.items.find(function(item){return item.variant_id===47215837085863;});
 var n=wrap?wrap.quantity:0;
 render(root,n);
 if(!wrap){
  root.querySelectorAll('[data-dg-contents],[data-dg-message]').forEach(function(el){el.value='';});
  cleanupZeroGiftCart();
 }
}
document.addEventListener('cart:updated',syncFromCartEvent);
if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
 subscribe(PUB_SUB_EVENTS.cartUpdate,function(event){
  if(busy)return;
  var root=panel();if(!root)return;
  var cart=event&&event.cart;
  if(cart&&Array.isArray(cart.items)){
   syncFromCartEvent({detail:{cart:cart}});
  }else{
   syncDrawerGift();
  }
 });
}



function panel(){return document.querySelector('[data-hm-drawer-gift]');}
function quantity(root){return root.querySelector('[data-dg-qty]');}
function render(root,n){n=Math.max(0,Math.min(20,Math.round(Number(n)||0)));quantity(root).value=n;root.querySelector('[data-dg-total]').textContent=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(n*8);root.querySelectorAll('[data-dg-gift]').forEach(function(p){p.hidden=Number(p.dataset.dgGift)>n;});return n;}
function fields(root,n){var a={'gift-wrapping-instructions':'','gift-note':''};root.querySelectorAll('[data-dg-contents]').forEach(function(e){a['gift '+e.dataset.dgContents+' contents']=n>0?e.value:'';});root.querySelectorAll('[data-dg-message]').forEach(function(e){a['gift '+e.dataset.dgMessage+' message']=n>0?e.value:'';});return a;}
async function post(url,body){var r=await fetch(url,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});if(!r.ok)throw Error('Shopify could not save');return r.json();}
async function save(root,n){
 if(busy)return;busy=true;var status=root.querySelector('[data-dg-status]'),details=root.querySelector('details'),saveBtn=root.querySelector('[data-dg-save]'),saveLabel=saveBtn?saveBtn.textContent:'save gift details';
 status.classList.remove('is-error');status.textContent='saving gift details...';
 if(saveBtn){saveBtn.classList.remove('is-saved');saveBtn.textContent='saving...';}
 root.querySelectorAll('button,input').forEach(function(el){el.disabled=true;});
 try{
  var wrapId=Number(root.dataset.wrapVariant),cart=await fetch('/cart.js',{credentials:'same-origin'}).then(function(r){if(!r.ok)throw Error('Could not load cart');return r.json();});
  var existing=cart.items.find(function(item){return item.variant_id===wrapId;});
  if(existing&&existing.quantity!==n)await post('/cart/change.js',{id:existing.key,quantity:n});
  else if(!existing&&n>0)await post('/cart/add.js',{items:[{id:wrapId,quantity:n}]});
  await post('/cart/update.js',{attributes:fields(root,n)});
  // Refresh only the actual Shopify cart items and subtotal. Keep the drawer,
  // its scroll position, expanded gift panel, and typed gift notes untouched.
  var htmlResponse=await fetch('/?section_id=mini-cart',{credentials:'same-origin'});
  if(!htmlResponse.ok)throw Error('Could not refresh cart display');
  var parsed=new DOMParser().parseFromString(await htmlResponse.text(),'text/html');
  var liveItems=document.querySelector('#mini-cart cart-items');
  var freshItems=parsed.querySelector('cart-items');
  if(!liveItems||!freshItems)throw Error('Could not find cart items');
  liveItems.innerHTML=freshItems.innerHTML;
  var freshSubtotal=parsed.querySelector('#mini-cart-subtotal');
  if(freshSubtotal){
   document.querySelectorAll('#mini-cart-subtotal').forEach(function(el){el.innerHTML=freshSubtotal.innerHTML;});
  }
  var verified=await fetch('/cart.js',{credentials:'same-origin'}).then(function(r){if(!r.ok)throw Error('Could not verify cart');return r.json();});
  var actual=verified.items.find(function(i){return i.variant_id===wrapId;});
  render(root,actual?actual.quantity:0);
  status.textContent='gift details saved ✓';
  if(saveBtn){saveBtn.textContent='saved ✓';saveBtn.classList.add('is-saved');setTimeout(function(){if(saveBtn){saveBtn.textContent=saveLabel;saveBtn.classList.remove('is-saved');}},2200);}
  root.querySelectorAll('button,input').forEach(function(el){el.disabled=false;});
 }catch(e){status.classList.add('is-error');status.textContent='could not save: '+e.message;if(saveBtn)saveBtn.textContent=saveLabel;root.querySelectorAll('button,input').forEach(function(el){el.disabled=false;});}
 finally{busy=false;}
}
document.addEventListener('click',function(event){
 var root=event.target.closest('[data-hm-drawer-gift]');if(!root||busy)return;
 if(event.target.closest('[data-dg-plus]')){event.preventDefault();save(root,render(root,Number(quantity(root).value)+1));}
 else if(event.target.closest('[data-dg-minus]')){event.preventDefault();save(root,render(root,Number(quantity(root).value)-1));}
 else if(event.target.closest('[data-dg-save]')){event.preventDefault();save(root,render(root,quantity(root).value));}
});
document.addEventListener('change',function(event){var root=event.target.closest('[data-hm-drawer-gift]');if(root&&event.target.matches('[data-dg-qty]')&&!busy)save(root,render(root,event.target.value));});
})();